import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useImmer } from 'use-immer';
import Header from "../common/Header";
import useAuth from "../../hooks/useAuth";
import $ from "jquery";
import { Link } from "react-router-dom";
import { dateFormat } from "../helpers/date";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Toastify from "../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { addTrailingZeros } from "../helpers/common";
import { BuyPriceTableRow } from "./BuyPriceTableRow";

function EnterBuyingPrice() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [orderDate, setOrderDate] = useState(dateFormat);
  const [orderDetails, setOrderDetails] = useImmer({});
  const [sortedOrderKeys, setSortedOrderKeys] = useImmer([]);
  const [products, setProducts] = useState([]);
  const [filterProduct, setFilterProduct] = useState(null);
  const [filterAgent, setFilterAgent] = useState(null);
  const [agents, setAgents] = useState([]);
  const [allAgentOrderData, setAllAgentOrderData] = useState([])
  const [allOrders, setAllOrders] = useState({})
  // state vars for form
  const [units, setUnits] = useState([]);
  const [toggleZeroBuyPrice, setToggleZeroBuyPrice] = useState(false);

  //bulkOrder details array to save at backend
  const [bulkOrderDetail, setBulkOrderDetail] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  // all agents list for update agent DropDown in table
  const [allAgents, setAllAgents] = useState([]);

  const [loading, setLoading] = useState(false);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
  const orderDetailsRef = useRef(orderDetails);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  }, []);
  useEffect(() => {
    if (allAgentOrderData.length === 0) return;

    const groupedOrders = {};
    const allOrders = [];

    const excludedKeys = ['tblAgent', 'tblOrder', 'tblUnit'];

    for (const item of allAgentOrderData) {
      const { OrderID, ODID, BPException, CntException, RRP, BuyPrice, tblOrder, tblAgent } = item;
      const order = tblOrder;
      const customer = order.tblCustomer;
      const agent = tblAgent;

      if (!groupedOrders[OrderID]) {
        groupedOrders[OrderID] = {
          OrderID,
          ODID,
          OrderDate: order.OrderDate,
          PurchaseOrder: order.PurchaseOrder,
          DeliveryInstructions: order.DeliveryInstructions,
          OrderNotes: order.OrderNotes,
          CustomerID: customer.CustomerID,
          AgentId: agent.AgentId,
          OrderDetails: []
        };
      }

      // Create filtered object
      const filteredItem = {};
      for (const key in item) {
        if (!excludedKeys.includes(key)) {
          filteredItem[key] = item[key];
        }
      }

      const orderDetail = {
        ...filteredItem,
        BPException: BPException ?? 0,
        CntException: CntException ?? 0,
        RRP: parseFloat(RRP || 0),
      };

      groupedOrders[OrderID].OrderDetails.push(orderDetail);

      allOrders.push({
        ...filteredItem,
        AgentCode: agent.AgentCode,
        BuyPrice: addTrailingZeros(BuyPrice),
        CustomerCode: customer.CustomerCode,
        BPException: BPException ?? 0,
        CntException: CntException ?? 0,
        RRP: parseFloat(RRP || 0),
      });
    }

    // Update state
    setBulkOrderDetail(Object.values(groupedOrders));

    // Sorting and object creation
    const sortedOrders = [...allOrders]
      .sort((a, b) => a.ProductName.localeCompare(b.ProductName))
      .sort((a, b) => a.AgentCode.localeCompare(b.AgentCode));

    const ordersObj = {};
    const sortedOrderKeys = [];

    for (const order of sortedOrders) {
      ordersObj[order.ODID] = order;
      sortedOrderKeys.push(order.ODID);
    }

    setSortedOrderKeys(sortedOrderKeys);
    setOrderDetails(ordersObj);
    setAllOrders(ordersObj);
  }, [allAgentOrderData]);


  useEffect(() => {
    // Resetting the OrderDetails when date is changed then api call is made for all agents in useEffect()
    setOrderDetails({});
    setSortedOrderKeys([]);
    setAllOrders({});
    setProducts([]);
    setAgents([]);
    fetchOrderDetails();
    setFilterProduct(null);
    setFilterAgent(null);
  }, [orderDate]);

  useEffect(() => {
    if (orderDetails && Object.keys(orderDetails).length > 0) {
      orderDetailsRef.current = orderDetails;
      requestAnimationFrame(() => {
        setLoading(false);
      });
    }
  }, [orderDetails]);


  const memoizedAgentData = useMemo(() => {
    return (
      allAgents?.map((agent) => {
        return ({
          label: agent.AgentCode, value: agent.AgentID
        })
      })
    )
  }, [allAgents]);

  const filterOptions = async (orderDetailsData) => {
    const uniqueProductNamesMap = new Map();
    const uniqueAgentsMap = new Map();

    orderDetailsData.forEach((order) => {
      if (!uniqueProductNamesMap.has(order.ProductName)) {
        uniqueProductNamesMap.set(order.ProductName, {
          label: order.ProductName,
          value: order.ProductName,
        });
      }

      if (order.tblAgent?.AgentCode && !uniqueAgentsMap.has(order.tblAgent.AgentCode)) {
        uniqueAgentsMap.set(order.tblAgent.AgentCode, {
          label: order.tblAgent.AgentCode,
          value: order.tblAgent.AgentId,
        });
      }
    });

    const uniqueProductNames = Array.from(uniqueProductNamesMap.values()).sort((a, b) =>
      a.label.localeCompare(b.label)
    );

    const uniqueAgents = Array.from(uniqueAgentsMap.values()).sort((a, b) =>
      a.label.localeCompare(b.label)
    );

    setProducts(uniqueProductNames);
    setAgents(uniqueAgents);
  }

  const fetchOrderDetails = async () => {
    let buyingSheetURL = process.env.REACT_APP_API_URL + `/print-buying-sheet`;
    let commanURL = process.env.REACT_APP_API_URL + "/get-comman-all-for-product";

    let payload = {
      "agentId": "All Agents",
      "fromDate": orderDate,
      "vpCodes": "all"
    }

    let buyingSheetResponse = await POSTREQUEST(buyingSheetURL, payload, user.jwtToken);
    let commanDataResponse = await GETREQUEST(commanURL, user.jwtToken);
    if (buyingSheetResponse?.data?.length > 0) {
      setLoading(true);
      setAllAgentOrderData(buyingSheetResponse.data);
      await filterOptions(buyingSheetResponse.data)
    }

    if (commanDataResponse?.data) {
      let unitList = [];
      commanDataResponse.data.units.forEach((item) => {
        unitList = [...unitList, { label: item.UnitName, value: item.UnitID }];
      });
      setUnits(unitList);

      setAllAgents(commanDataResponse.data.agent);
    }
  }

  const saveBulkOrder = async () => {
    setSaveBtnDisabled(true);
    let buyingSheetURL = process.env.REACT_APP_API_URL + `/update-orders-details`;
    setMessage('');
    setMessageType('');

    const updatedBulkOrderDetail = bulkOrderDetail.map(item => {
      let updatedItem = {
        CustomerID: item.CustomerID,
        OrderID: item.OrderID,
        OrderDate: item.OrderDate,
      }
      const updatedOrderDetails = item.OrderDetails.map(detailItem => {
        let orderItem = orderDetails[detailItem.ODID];
        orderItem = {
          ODID: orderItem.ODID,
          Qty: orderItem.Qty,
          UnitID: orderItem.UnitID,
          ProductID: orderItem.ProductID,
          ProductCode: orderItem.ProductCode,
          AgentID: orderItem.AgentID,
          Count: orderItem.Count,
          CntException: orderItem.CntException,
          IgnoreCrate: orderItem.IgnoreCrate,
          SellPrice: orderItem.SellPrice,
          BuyPrice: orderItem.BuyPrice,
          BPException: orderItem.BPException,
          AgentCode: orderItem.AgentCode
        }
        return orderItem;
      });
      return { ...updatedItem, OrderDetails: updatedOrderDetails };
    });

    let response = await POSTREQUEST(buyingSheetURL, updatedBulkOrderDetail, user.jwtToken);
    if (response?.data) {
      setMessage(response.data.message);
      if (response.data.success) {
        //fetchOrderDetails()
        setMessageType("success")
      } else {
        setMessageType("error")
      }
    }
    else {
      setMessageType("error");
      setMessage(response?.error?.message || "Somethig went wrong !")
    }
    setSaveBtnDisabled(false);
  }

  const CustomOptionAgent = (props) => {
    return (
      <div>
        <div
          className=""
          style={{
            background: props.isFocused
              ? '#01B1E3'
              : props.isSelected
                ? 'rgb(54, 179, 126)'
                : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
          }}
          {...props.innerProps}
          ref={props.innerRef}
        >
          {props.label}
        </div>
      </div>
    )
  }

  const handleInputChange = useCallback((value, key, index) => {
    setOrderDetails(draft => {
      draft[index][key] = value;
    });
  }, []);

  const handleCountChange = useCallback((orderDetailItem) => {
    const similarProducts = Object.values(orderDetailsRef?.current)?.filter(orderdetailsItem => orderdetailsItem.ProductCode === orderDetailItem.ProductCode);

    if (!orderDetailItem.CntException) {
      similarProducts?.map((updateOrder) => {
        let updateOrderItem = orderDetailsRef.current[updateOrder.ODID]
        if (updateOrderItem && !updateOrderItem.CntException) {
          handleInputChange(orderDetailItem.Count, 'Count', updateOrder.ODID)
        }
      })
    }

  }, []);

  const handleBuyPriceChange = useCallback((orderDetailItem) => {
    const similarProducts = Object.values(orderDetailsRef?.current)?.filter(orderdetailsItem => orderdetailsItem.ProductCode === orderDetailItem.ProductCode);

    if (!orderDetailItem.BPException) {
      similarProducts?.map((updateOrder) => {
        let updateOrderItem = orderDetailsRef.current[updateOrder.ODID]
        if (updateOrderItem && !updateOrderItem.BPException) {
          handleInputChange(addTrailingZeros(orderDetailItem.BuyPrice), 'BuyPrice', updateOrder.ODID)
        }
      })
    }

  }, []);

  const shouldRenderOrderItem = (orderDetailItem, filterAgent, filterProduct, toggleZeroBuyPrice) => {
    if (!orderDetailItem || (filterAgent !== null && orderDetailItem.AgentID !== filterAgent) ||
      (filterProduct !== null && orderDetailItem.ProductName !== filterProduct?.value) ||
      (toggleZeroBuyPrice && parseFloat(orderDetailItem.BuyPrice))
    ) { return false }
    return true;
  }

  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-orders"
                    className="text-decoration-none text-primary"
                  >
                    Orders
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Enter Buying Price
                </li>
              </ol>
            </nav>
          </div>
          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Enter Buying Price
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="custom-group flex-nowrap mb-xl-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Ship date:
                  </label>
                  <div
                    className="position-relative cme-15"
                    data-provide="datepicker"
                  >
                    <input
                      type="date"
                      id="datepicker"
                      className="form-control input-sm date input-datepicker"
                      placeholder="Select Date"
                      defaultValue={orderDate}
                      onChange={(e) => {
                        setOrderDate(e.target.value);

                      }}
                    />
                  </div>
                </div>
                <div className="custom-group flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Agent
                  </label>
                  <div className="cme-15 d-flex align-items-center">
                    <Select
                      className="input-sm  input-width-160"

                      defaultValue={"Select Agent"}
                      value={filterAgent}
                      options={agents}
                      placeholder="Select Agent"
                      onChange={(e) => { setFilterAgent(e.value); setFilterProduct(null); }}
                      components={{ Option: CustomOptionAgent }}
                    />
                    <button
                      type="button"
                      className={`btn-close ${filterAgent ? "d-block" : "d-none"
                        }`}
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style={{
                        color: "black",
                        opacity: 1,
                        fontSize: 12,
                        padding: "16px",
                      }}
                      onClick={() => { setFilterAgent(null); setFilterProduct(null); }}
                    ></button>
                  </div>
                </div>
                {/* Product search Field */}
                <div className="custom-group flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Product
                  </label>
                  <div className="cme-15 d-flex align-items-center">
                    <Select
                      className="input-sm  input-width-400"
                      defaultValue={"Select Product"}
                      value={filterProduct}
                      options={products}
                      placeholder="Select Product"
                      onChange={(e) => { setFilterProduct(e); setFilterAgent(null); }}
                      components={{ Option: CustomOptionAgent }}
                    />
                    <button
                      type="button"
                      className={`btn-close ${filterProduct ? "d-block" : "d-none"
                        }`}
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style={{
                        color: "black",
                        opacity: 1,
                        fontSize: 12,
                        padding: "16px",
                      }}
                      onClick={() => { setFilterProduct(null); setFilterAgent(null) }}
                    ></button>
                  </div>
                </div>
              </div>
              <button
                type="button"
                onClick={(e) => setToggleZeroBuyPrice(!toggleZeroBuyPrice)}
                disabled={Object.keys(allOrders)?.length === 0}
                className={`btn btn-sm d-flex align-items-center px-4  fw-medium rounded-3 ms-3 text-nowrap ${toggleZeroBuyPrice
                  ? "btn-secondary text-white"
                  : "btn-outline-secondary"
                  }`}
              >
                Only Zero
              </button>
            </div>
            <div className="card-body p-4 border-bottom">
              <div className="card-table table-responsive">
                <table className="table table-form">
                  <thead>
                    <tr>
                      <td scope="col" className="width-lg-1"></td>
                      <td scope="col" className="width-lg-6">
                        Agent
                      </td>
                      <td scope="col" className="width-lg-6">
                        Customer
                      </td>
                      <td scope="col" className="width-lg-5">
                        Qty
                      </td>
                      <td scope="col" className="width-lg-6">
                        Unit
                      </td>
                      <td scope="col">Products</td>
                      <td scope="col" className="width-lg-1"></td>
                      <td scope="col" className="width-lg-5">
                        Cnt/Wt
                      </td>
                      <td scope="col" className="width-lg-1"></td>
                      <td scope="col" className="width-lg-6">
                        Buy Price
                      </td>
                      <td scope="col" className="width-lg-1"></td>
                    </tr>

                  </thead>
                  <tbody>
                    {loading && (
                      <tr className="position-absolute w-100 ">
                        <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                          <div className="overlay">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {sortedOrderKeys?.map((key) => {
                      let orderDetailItem = orderDetails[key];
                      if (!shouldRenderOrderItem(orderDetailItem, filterAgent, filterProduct, toggleZeroBuyPrice)) return null;
                      const agentSelectedValue = memoizedAgentData.find((agent) => agent.value === orderDetailItem.AgentID);
                      const unitSelectedValue = units.find((item) => item.value === orderDetailItem.UnitID);

                      return <BuyPriceTableRow key={orderDetailItem.ODID} agentSelectedValue={agentSelectedValue} unitSelectedValue={unitSelectedValue} orderDetailItem={orderDetailItem} allAgents={memoizedAgentData} units={units} handleInputChange={handleInputChange} handleCountChange={handleCountChange} handleBuyPriceChange={handleBuyPriceChange} />
                    }
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-sm-12 d-flex justify-content-end">
                  <nav
                    aria-label="Page navigation example"
                    className="d-flex align-items-center"
                  >
                    <p className="mb-0 mt-3 text-lite fs-14">
                      Link Count: <span className="text-dark fs-15">5</span>
                    </p>
                  </nav>
                </div>
              </div>
              {!message && <div className="text-center"><span className='text-danger'>Kindly Save the Data before Exit Otherwise Data will be lost</span></div>}
              <div className="row">
                <div className="col d-flex justify-content-end align-items-end">
                  <button type="button" onClick={saveBulkOrder}
                    to="/print-sheet"
                    disabled={saveBtnDisabled}
                    className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3 mx-2"
                  >
                    Save
                  </button>
                  <button type="button" onClick={() => navigate("/veg-art")}
                    className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                  >
                    Exit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default EnterBuyingPrice;